import React, { useContext, useEffect, useState } from "react";
import "./Deposit.css";
import Section_Header_Bar from "../../common_components/section_header_bar/Section_Header_Bar";
import { Form } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_components/common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import Inner_Footer_Text_Component from "../../common_components/inner_footer_text_component/Inner_Footer_Text_Component";
import Successfull_Modal from "../../common_components/common_modal/successfull_modal/Successfull_Modal";
import { ApSetup } from "../../../utils/apis/master/Master";
import { postDepositMoney } from "../../../utils/apis/deposit/deposit";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../utils/context";
import { QRCodeSVG } from "qrcode.react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Deposit = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [appSetup, setAppSetup] = useState({});
  const [preview, setPreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { userdata, getuserData, signin, IMG_URL } = useContext(Context);

  const {
    register,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm();

  const getAppSetup = async () => {
    const res = await ApSetup();
    if (res?.success) {
      setAppSetup(res.data);
    }
  };

  useEffect(() => {
    getAppSetup();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
    }
  };

  const onSubmit = async (data) => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("image", data.image[0]);
    formData.append("amount", data.amount);

    try {
      const res = await postDepositMoney(formData);

      if (res?.success) {
        toast.success("Deposit request submitted successfully!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "dark",
        });

        getuserData(userdata?.id);
        setShowModal(true);
        setTimeout(() => {
          navigate("/my-account");
          setShowModal(false);
        }, 3000);
      } else {
        const msg = res?.message || "Deposit failed";
        setError("amount", { message: msg });
        toast.error(msg, { position: "bottom-right" });
      }
    } catch (error) {
      console.error("API Error:", error);
      const errMsg = "An error occurred. Please try again.";
      setError("amount", { message: errMsg });
      toast.error(errMsg, { position: "bottom-right" });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="deposit-page">
      <ToastContainer position="bottom-right" theme="dark" />

      <div className="header-wrapper">
        <Section_Header_Bar />
      </div>

      <div className="deposit-container">
        <h1 className="page-title">Deposit Funds</h1>

        <div className="deposit-content-grid">
          {/* Left Column - Deposit Form */}
          <div className="qr-card ">
            <div className="card-header text-center pt-3 px-3">
              {/* <h2 className="card-title">Crypto Address</h2> */}
              <p className="card-subtitle max-md:mx-auto">Scan & Pay Instantly</p>
            </div>

            <div className="qr-content">
              {appSetup?.qr_image ? (
                <>
                  <div className="qr-wrapper">
                    <img
                      src={IMG_URL + appSetup?.qr_image}
                      alt="UPI QR Code"
                      className="qr-image"
                    />
                  </div>

                  {appSetup?.upi_id && (
                    <div className="upi-info">
                      <p className="upi-id-label ">Crypto Address:</p>
                      <div className="relative group">
  <p
    className="
      upi-id 
      !text-sm 
      break-all           /* forces long strings to break into new lines */
      cursor-pointer      /* indicates it's clickable */
      hover:underline     /* visual feedback */
      transition-colors
      text-blue-400       /* optional: make it look clickable */
    "
    onClick={() => {
      navigator.clipboard.writeText(appSetup?.upi_id || "");
      toast.success("Address copied to clipboard!", {
        position: "bottom-right",
        autoClose: 2000,
      });
    }}
  >
    {appSetup?.upi_id || "Not set"}
  </p>

  {/* Optional tiny tooltip on hover */}
  <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-gray-800 text-white text-xs rounded px-2 py-1 whitespace-nowrap">
    Click to copy
  </span>
</div>
                      {/* <p className="copy-tip">Tap to copy Crypto Address</p> */}
                    </div>
                  )}
                </>
              ) : (
                <div className="no-qr">
                  <p>No UPI QR available at the moment</p>
                  <p>Please use bank transfer or contact support</p>
                </div>
              )}
            </div>
          </div>

          {/* Right Column - QR / UPI Section */}
          <div className="  deposit-form-card">

            <div className="card-header text-center pt-3 px-3 max-md:flex max-md:flex-col">
              <h2 className="card-title">Deposit to Wallet</h2>
              <p className="card-subtitle">
                Enter amount and upload payment proof
              </p>
            </div>

            <Form onSubmit={handleSubmit(onSubmit)} className="deposit-form">
              <div className="form-grid">
                {/* Deposit Amount */}
                <div className="form-group">
                  <label className="form-label">Deposit Amount (USD)</label>
                  <Form.Control
                    className="modern-input"
                    type="number"
                    step="0.01"
                    placeholder="Enter amount"
                    {...register("amount", {
                      required: "Deposit amount is required",
                      min: {
                        value: appSetup?.min_fund_deposit || 1,
                        message: `Minimum deposit is $${appSetup?.min_fund_deposit}`,
                      },
                    })}
                    disabled={isSubmitting}
                  />
                  {errors.amount && (
                    <p className="error-text">{errors.amount.message}</p>
                  )}
                </div>

                {/* Payment Proof */}
                <div className="form-group">
                  <label className="form-label">Payment Proof (Image)</label>
                  <div className="file-upload-wrapper">
                    <Form.Control
                      className="modern-file-input"
                      type="file"
                      accept="image/*"
                      {...register("image", {
                        required: "Payment proof image is required",
                      })}
                      onChange={handleImageChange}
                      disabled={isSubmitting}
                    />
                    <span className="file-upload-label">
                      {preview ? "Image Selected" : "Choose Image"}
                    </span>
                  </div>
                  {errors.image && (
                    <p className="error-text">{errors.image.message}</p>
                  )}

                  {preview && (
                    <div className="image-preview">
                      <img src={preview} alt="Payment Proof Preview" />
                    </div>
                  )}
                </div>
              </div>

              <div className="fee-info">
                <p>
                  Minimum deposit: <strong>${appSetup?.min_fund_deposit || 1}</strong>
                </p>
                <p>
                  Deposit fee: <strong>{appSetup?.deposit_percent ?? 0}%</strong> will be deducted
                </p>
              </div>

              {signin ? (
                <Orange_White_Border_Btn
                  btn_name={isSubmitting ? "Submitting..." : "Submit Deposit"}
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                />
              ) : (
                <Orange_White_Border_Btn
                  btn_name="Login to Deposit"
                  onClick={() => navigate("/login")}
                  className="submit-btn"
                />
              )}
            </Form>

            
            
          </div>
        </div>

        <div className="footer-text-wrapper">
          <Inner_Footer_Text_Component />
        </div>
      </div>

      <Successfull_Modal
        message="Deposit Request Sent Successfully!"
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Deposit;